<template>
    <label class="flex items-center gap-3 cursor-pointer select-none w-full text-slate-700">
        <input type="radio" :name="radioName" :value="value" :checked="modelValue === value" @change="modelValue = value" class="appearance-none size-5rounded-full border-2 border-slate-400 checked:border-primary checked:bg-primary transition" />
        <slot />
    </label>
</template>

<script setup>
const props = defineProps({
    value: {
        type: String,
        required: true,
    },
    name: {
        type: String,
        default: null,
    },
})

const injectedName = inject('radioName')
const modelValue = inject('radioModel')

const radioName = computed(() => props.name ?? injectedName)
</script>
